import React, { useEffect, useState } from 'react';

export function CompassNeedle({ imgSrc, size = 120 }) {
  const [rotation, setRotation] = useState(0);

  useEffect(() => {
    function handleOrientation(event) {
      // Alpha ist die Rotation relativ zum Norden (in Grad)
      if (event.absolute === true || event.webkitCompassHeading) {
        // iOS gibt webkitCompassHeading (0=N, 90=E, ...)
        setRotation(event.webkitCompassHeading || 360 - event.alpha);
      } else if (event.alpha !== null) {
        setRotation(360 - event.alpha);
      }
    }

    window.addEventListener('deviceorientation', handleOrientation, true);
    return () => window.removeEventListener('deviceorientation', handleOrientation);
  }, []);

  return (
    <div style={{
      width: size,
      height: size,
      margin: 'auto',
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      <img
        src={imgSrc}
        alt="Kompass-Nadel"
        style={{
          width: size,
          height: size,
          transform: `rotate(${rotation}deg)`,
          transition: 'transform 0.2s linear',
          pointerEvents: 'none',
          position: 'absolute',
          left: 0,
          top: 0
        }}
      />
    </div>
  );
}
